import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { cvStyles } from '../cvStyles';
import { cvConfig } from '../cvConfig';

/**
 * Componente About del CV
 * Muestra la descripción personal
 */
export const CVAbout = ({ about }) => {
  if (!about || !about.description) return null;

  // Limpiar HTML tags si existen en la descripción
  const cleanDescription = about.description.replace(/<[^>]*>/g, '');

  // Truncar si excede el límite configurado
  const maxLength = cvConfig.limits.descriptionLength;
  const description = cleanDescription.length > maxLength
    ? cleanDescription.substring(0, maxLength) + '...'
    : cleanDescription;

  return (
    <View style={cvStyles.section}>
      <Text style={cvStyles.sectionTitle}>Sobre mí</Text>
      <Text style={cvStyles.aboutText}>{description}</Text>
    </View>
  );
};
